/**
 * Bus interno (no window) para mensajes entrantes ya normalizados.
 * Flujo principal: socketService (`chat:message` / sync) → publish → NotificationContext (sonido) + vistas que suscriban.
 */

const listeners = new Set();

/**
 * @param {(detail: object) => void} handler
 * @returns {() => void} unsubscribe
 */
export function subscribeIncomingChatMessage(handler) {
  if (typeof handler !== 'function') return () => {};
  listeners.add(handler);
  return () => listeners.delete(handler);
}

/**
 * @param {object} detail - payload tipo event.detail anterior (archat:new_message)
 */
export function publishIncomingChatMessage(detail) {
  if (detail == null || typeof detail !== 'object') return;
  listeners.forEach((fn) => {
    try {
      fn(detail);
    } catch (_) {
      // noop
    }
  });
}
